import { FC } from 'react'

interface FilterStatusProps {
  totalResults: number
  filteredResults: number
}

const FilterStatus: FC<FilterStatusProps> = ({ totalResults, filteredResults }) => {
  return (
    <div className="py-2 text-xs text-muted-foreground bg-muted/20">
      Showing <span className="font-medium">{filteredResults}</span> of{' '}
      <span className="font-medium">{totalResults}</span> results
    </div>
  )
}

export default FilterStatus
